export var KeyCodeName;
(function (KeyCodeName) {
    KeyCodeName["ArrowUp"] = "ArrowUp";
    KeyCodeName["ArrowUpIE11"] = "Up";
    KeyCodeName["ArrowDown"] = "ArrowDown";
    KeyCodeName["ArrowDownIE11"] = "Down";
    KeyCodeName["ArrowLeft"] = "ArrowLeft";
    KeyCodeName["ArrowLeftIE11"] = "Left";
    KeyCodeName["ArrowRight"] = "ArrowRight";
    KeyCodeName["ArrowRightIE11"] = "Right";
    KeyCodeName["Enter"] = "Enter";
    KeyCodeName["Backspace"] = "Backspace";
    KeyCodeName["Delete"] = "Delete";
    KeyCodeName["Escape"] = "Escape";
    KeyCodeName["Tab"] = "Tab";
})(KeyCodeName || (KeyCodeName = {}));
//# sourceMappingURL=key-code-name.type.js.map